const PRESERVED_LOCAL_STORAGE_KEYS = new Set([
  "qetero.user",
  "qetero.currentUserPhone",
  "qetero.token",
  "token",
  "language",
  "qetero.unregistered but verified",
  "cbe_birr_plus_token",
])

const PRESERVED_SESSION_STORAGE_KEYS = new Set([
  "qetero.pendingBooking",
])

export function clearAppCache(): void {
  if (typeof window === "undefined") return

  const keysToRemove: string[] = []
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (key && !PRESERVED_LOCAL_STORAGE_KEYS.has(key)) {
      keysToRemove.push(key)
    }
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key))

  const sessionKeysToRemove: string[] = []
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i)
    if (key && !PRESERVED_SESSION_STORAGE_KEYS.has(key)) {
      sessionKeysToRemove.push(key)
    }
  }
  sessionKeysToRemove.forEach((key) => sessionStorage.removeItem(key))
}
